import {DataTransferObjectValidation} from "../../../type/Types";
import {PulymShoppingValueObject} from "../../vo/pulym/PulymShoppingValueObject";

export namespace PulymDataTransferObject {
    export type Post = {
        is_tomorrow: boolean
    }

    export namespace Post {
        export const description: Record<keyof Post, string> = PulymShoppingValueObject.description

        export const validation: DataTransferObjectValidation<Post> = {
            is_tomorrow(o: string): boolean {
                return o === 'true'
            },
        }
    }

}

